export default {
  municipios: [
    {
      id: 27,
      name: "Tocantins",
      state_initials: "TO",
      capital: "Palmas",
    },
    {
      id: 17,
      name: "Rio",
      state_initials: "RJ",
      capital: "Rio",
    },
  ],
  municipio: null,
  estados: [],
  estado: null,
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
